export const firebaseConfig = {
  apiKey: "AIzaSyATZ2oyXVDZdg2EUQYQuXVGTVmyws91RMI",
  authDomain: "video.hantalk.org",
  databaseURL: "https://hantalk-video.firebaseio.com",
  projectId: "hantalk-video",
  storageBucket: "hantalk-video.appspot.com",
  messagingSenderId: "751520654195"
};
